import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { axiosInstance } from '../../../helpers'
import { Report } from '../../../models'

export interface UseLeaseAuditReportsOptions {
    auditId: number
    enabled?: boolean
}

export const useLeaseAuditReports = (options: UseLeaseAuditReportsOptions) => {
    const { auditId, enabled = true } = options

    // Fetch reports for this audit
    const { data: reportsData, isLoading, error, refetch } = useQuery<
        AxiosResponse<Report[]>,
        Error
    >({
        queryKey: ['leaseAuditReports', auditId],
        queryFn: () => axiosInstance.get(`/lease-audit/${auditId}/reports/`),
        enabled: enabled && !!auditId,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })

    const reports = reportsData?.data ?? []

    return {
        reports,
        isLoading,
        error,
        refetch,
    }
}
